// import { CareEmbeddedType, InjectCareInfo } from 'interfaces/types'

// /**
//  * @param careEmbedded care embedded like '/type="doctor"/id="123"'
//  * @returns
//  */
// const formatInjectedCareInfo = (careEmbedded: any): InjectCareInfo | null => {
//   if (typeof careEmbedded !== 'string') {
//     return null
//   }

//   return {
//     type: (/type="(.*?)"/gi.exec(careEmbedded)?.[1] || '') as CareEmbeddedType,
//     dataId: /id="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
//     dataTitle: /title="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
//     dataDescription: /description="(.*?)"/gi.exec(careEmbedded)?.[1] || '',
//   }
// }

// export { formatInjectedCareInfo }

export type ToolPageType = 'form' | 'result' | 'records'

export const addResultToLink = (link: string) => {
  return link.includes('?result=1')
    ? link
    : link.includes('?')
    ? link.replace('?', '?result=1&')
    : link + '?result=1'
}
